"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Watching = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Watching = function () { return (react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11.993 4a12.772 12.772 0 0111.992 8.04c.02.12.02.242 0 .36a.971.971 0 01-.072.397 12.772 12.772 0 01-11.92 8.004A12.772 12.772 0 01.072 12.773.973.973 0 010 12.4a1.2 1.2 0 01.072-.396A12.772 12.772 0 0111.992 4zm-3.598 8.4a3.599 3.599 0 103.598-3.6 3.599 3.599 0 00-3.598 3.6z", clipRule: "evenodd" })); };
exports.Watching = Watching;
//# sourceMappingURL=watching.js.map